<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="codigo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarTipoContrato">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import TipoContrato from '../../../services/TipoContrato'
export default {
    name:'Crear',
    props:['modalCrear'],
    data:() => ({
        codigo : "",
        descripcion : "",
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear tipo contrato",
                    codigo : "Código",
                    descripcion : "Descripción",
                    save : "Guardar",
                    close : "Cerrar"
                }
            }else{
                return {
                    title: "Create contract type",
                    codigo : "Code",
                    descripcion : "Description",
                    save : "Sava",
                    close : "Close"
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTipoContrato(){
            if(this.codigo == '' || this.descripcion == ''){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'codigo' : this.codigo,
                    'descripcion' : this.descripcion,
                    'idUser' : this.$store.state.userId
                }
                
                TipoContrato.createTipoContrato(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo contrato ya existe.')
                    }
                })
                .catch((error) => error)
            }
        }
    }
}
</script>

<style>

</style>